import PropTypes from 'prop-types';
import React from 'react';
import Loader from 'react-loader-spinner';
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';
import { Centro, Linha } from '../../styles/base';

const ListaTransportes = ({
  empresa, linha,
}) => (
  <div
    className="controle-fundo"
    style={{
      border: '1px solid #c1c1c1', padding: '5px 20px', background: '#f1f1f1',
    }}
  >
    <Linha style={{ display: 'flex', justifyContent: 'space-between' }}>
      {linha && (
      <p style={{ fontWeight: 'bold' }}>
        {linha}
      </p>
      )}
      {empresa && (
      <p>
        <span style={{ fontWeight: 'bold' }}>Empresa: </span>
        {empresa}
      </p>
      )}
    </Linha>
  </div>
);

ListaTransportes.propTypes = {
  empresa: PropTypes.string,
  linha: PropTypes.string,
};

ListaTransportes.defaultProps = {
  empresa: '',
  linha: '',
};

export default ListaTransportes;
